<div class="dynamic-component">
	<ng-template #loader> </ng-template>

	<div class="content">
		<flx-tabs class="tabs" [tabs]="tabs" [currentStep$]="currentTab$" [externalPages]="true" (outputEventStream)="handleTab($event)">
			<flx-heading size="medium" align="center" weight="extra-light"> {{ location === 'flow-photos' ? 'Photos' : 'Documents' }}</flx-heading>

			<!-- Supporting Documents catch-all (files not in explicit sections) -->
			<ng-container *ngIf="useDynamicTab">
				<div id="supporting-documents" class="tab-content" contents="supporting-documents" *ngIf="((currentTab$ | async) ?? '') === 'supporting-documents'">
					<ng-container *ngIf="supportingDocuments$ | async as files; else loader">
						<flx-file-browser
							[showFilters]="false"
							thumbSize="100px"
							paginationId="supporting-documents"
							*ngIf="hasFiles(files); else noSupportingDocuments"
							[files$]="supportingDocuments$"
							display="image-grid"
							[location]="location"
						></flx-file-browser>
					</ng-container>
					<ng-template #noSupportingDocuments>
						<flx-alert type="no-info" missingItem="supporting documents"></flx-alert>
					</ng-template>
				</div>
			</ng-container>

			<!-- Dynamic tabs from documentTabsConfig (e.g. tenant required_documents) -->
			<ng-container *ngIf="!useDynamicTab && useDynamicTabs && documentTabsConfig">
				<ng-container *ngFor="let tab of documentTabsConfig">
					<div
						*ngIf="((currentTab$ | async) ?? '') === tab?.targetId"
						[id]="tab?.targetId"
						class="tab-content"
						[attr.contents]="tab?.targetId"
					>
						<ng-container *ngIf="getFilesForTab(tab) | async as files; else loader">
							<flx-file-browser
								[showFilters]="false"
								thumbSize="100px"
								[paginationId]="tab?.targetId ?? 'documents'"
								*ngIf="hasFiles(files); else noFiles"
								[files$]="getFilesForTab(tab)"
								[display]="getDisplayMode(tab)"
								[location]="location"
							></flx-file-browser>
						</ng-container>
						<ng-template #noFiles>
							<flx-alert type="no-info" [missingItem]="tab.display"></flx-alert>
						</ng-template>
					</div>
				</ng-container>
			</ng-container>

			<!-- Legacy fixed tabs -->
			<ng-container *ngIf="!useDynamicTabs">
				<div id="photos" class="tab-content" contents="photos" *ngIf="((currentTab$ | async) ?? '') === 'photos'">
					<ng-container *ngIf="photos$ | async as photos; else loader">
						<flx-file-browser
							[showFilters]="false"
							paginationId="photos"
							*ngIf="hasFiles(photos); else noPhotos"
							[files$]="photos$"
							display="image-grid"
							[location]="location"
						></flx-file-browser>
					</ng-container>
					<ng-template #noPhotos> <flx-alert type="no-info" missingItem="photos"></flx-alert> </ng-template>
				</div>

				<div id="quotations" class="tab-content" contents="quotations" *ngIf="((currentTab$ | async) ?? '') === 'quotations'">
					<ng-container *ngIf="quotations$ | async as quotations; else loader">
						<flx-file-browser
							[showFilters]="false"
							paginationId="quotations"
							*ngIf="hasFiles(quotations); else noQuotations"
							[files$]="quotations$"
							display="file-grid"
							[location]="location"
						></flx-file-browser>
					</ng-container>
					<ng-template #noQuotations> <flx-alert type="no-info" missingItem="quotations"></flx-alert> </ng-template>
				</div>

				<div id="invoices" class="tab-content" contents="invoices" *ngIf="((currentTab$ | async) ?? '') === 'invoices'">
					<ng-container *ngIf="invoices$ | async as invoices; else loader">
						<flx-file-browser
							[showFilters]="false"
							paginationId="invoices"
							*ngIf="hasFiles(invoices); else noInvoices"
							[files$]="invoices$"
							display="file-grid"
							[location]="location"
						></flx-file-browser>
					</ng-container>
					<ng-template #noInvoices> <flx-alert type="no-info" missingItem="invoices"></flx-alert> </ng-template>
				</div>

				<div id="reports" class="tab-content" contents="reports" *ngIf="((currentTab$ | async) ?? '') === 'reports'">
					<ng-container *ngIf="reports$ | async as reports; else loader">
						<flx-file-browser
							[showFilters]="false"
							paginationId="reports"
							*ngIf="hasFiles(reports); else noReports"
							[files$]="reports$"
							display="file-grid"
							[location]="location"
						></flx-file-browser>
					</ng-container>
					<ng-template #noReports> <flx-alert type="no-info" missingItem="reports"></flx-alert> </ng-template>
				</div>
				<div id="latest-documents" class="tab-content" contents="latest-documents" *ngIf="((currentTab$ | async) ?? '') === 'latest-documents'">
					<flx-heading size="extra-small" align="center" weight="extra-light">Latest Quotation, Invoice and Report </flx-heading>
					<ng-container *ngIf="latestDocuments$ | async as latestDocuments; else loader">
						<flx-file-browser
							[showFilters]="false"
							paginationId="latest-documents"
							*ngIf="hasFiles(latestDocuments); else noLatestDocuments"
							[files$]="latestDocuments$"
							display="file-grid"
							[location]="location"
						></flx-file-browser>
					</ng-container>
					<ng-template #noLatestDocuments> <flx-alert type="no-info" missingItem="documents"></flx-alert> </ng-template>
				</div>
			</ng-container>
		</flx-tabs>
	</div>
</div>
